module.exports = __webpack_public_path__ + "img/Recurso 6.19a5501c.png";